import {useEffect,useState} from 'react';
import {Link} from 'react-router-dom';
import {TriangleAlert} from 'lucide-react';
import type {Channel} from '../../lib/types';
import {expiryMessage,expiryWarnings} from './expiryWarnings';

// Recomputed hourly from already loaded workspace data, so the countdown moves without polling providers.
export function ExpiryBanner({channels,userId}:{channels:Channel[];userId?:string}) {
  const [now,setNow]=useState(()=>Date.now());
  useEffect(()=>{const timer=setInterval(()=>setNow(Date.now()),3_600_000);return ()=>clearInterval(timer)},[]);
  const warnings=expiryWarnings(channels,now,userId);
  if(!warnings.length)return null;
  return <div className="notice warning connection-expiry" role="status">
    <TriangleAlert size={18} aria-hidden="true"/>
    <div>{warnings.map(warning=><p key={warning.connectionId}>{expiryMessage(warning)}</p>)}
      {warnings.some(warning=>warning.canReconnect)&&<Link className="text-link" to="/settings">Gå til Indstillinger</Link>}</div>
  </div>;
}
